import { initializeClientLogging } from "@dutyon/apis";
import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App.tsx";
import { RootProvider } from "./providers/RootProvider.tsx";
import "@dutyon/ui-kit/styles.css";

// Google Analytics 4 및 Firebase 로깅 초기화
void initializeClientLogging("대시보드");

import "dayjs/locale/ko";
import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
import isBetween from "dayjs/plugin/isBetween";
import isSameOrAfter from "dayjs/plugin/isSameOrAfter";
import isSameOrBefore from "dayjs/plugin/isSameOrBefore";

dayjs.extend(customParseFormat);
dayjs.extend(isBetween);
dayjs.extend(isSameOrAfter);
dayjs.extend(isSameOrBefore);
dayjs.locale("ko");

const rootElement = document.getElementById("root");

if (!rootElement) {
  throw new Error("대시보드를 표시할 루트 요소를 찾을 수 없습니다.");
}

ReactDOM.createRoot(rootElement).render(
  <React.StrictMode>
    <RootProvider>
      <App />
    </RootProvider>
  </React.StrictMode>,
);
